import moment from "moment";

function _params(key) {
  let search = window.location.search;
  let arr = search.split("?");
  let params = new URLSearchParams(arr[1]);
  let value_params = params.get(`${key}`);
  if (value_params) {
    return value_params;
  }
  return null;
}

function getParamUrl() {
  let search = window.location.search;
  let arr = search.split("?");
  let params = new URLSearchParams(arr[1]);
  let token = params.get("token");
  return token;
}

function getParamUrlByKey(keyparame) {
  let search = window.location.search;
  let arr = search.split("?");
  let params = new URLSearchParams(arr[1]);
  let res;

  if (keyparame) {
    res = params.get(keyparame);
  }
  return res;
}

function _formatMoney(str) {
  if (str) {
    return str
      .toString()
      .replace(/\./, ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  return 0;
}

function _validPhone(phone1) {
  // carrier 1 là vietel, 2 là mobi, 3 là vina
  var phone = phone1.substr(0, 3);
  var viettel = /((086|096|097|098|032|033|034|035|036|037|038|039))/g;
  var mobi = /((089|090|093|070|071|072|076|077|078|079))/g;
  var vina = /((088|091|094|083|084|085|081|082))/g;
  var vietnamobile = /((092|056|058))/g;
  var gmobile = /((099|059))/g;
  var sFone = /((095))/g;

  if (phone.toString().length !== 10) return "Số điện thoại phải đủ 10 số";

  if (
    viettel.test(phone) ||
    mobi.test(phone) ||
    vina.test(phone) ||
    vietnamobile.test(phone) ||
    gmobile.test(phone) ||
    sFone.test(phone)
  ) {
    return "";
  } else {
    return "Số điện thoại không đúng";
  }
}

// add effective date less than 1 year vungtaman
function _addEffectiveDate(year, number) {
  var time = year.split("/");
  var yearr = "";
  var month = "";
  var day = "";
  let resultAddMonth = "";

  if (number === 1) {
    resultAddMonth = moment(`${time[2]}-${time[1]}-${time[0]}`)
      .add(12, "M")
      .format("YYYY-MM-DD");
  } else {
    resultAddMonth = moment(`${time[2]}-${time[1]}-${time[0]}`)
      .add(number, "M")
      .format("YYYY-MM-DD");
  }

  day = resultAddMonth.split("-")[2];
  month = resultAddMonth.split("-")[1];
  yearr = resultAddMonth.split("-")[0];

  var c = day + "/" + month + "/" + yearr;
  // var c = yearr + '-' + month + '-' + day;

  return c;
}

function _getTPlatformParamUrl() {
  let search = window.location.search;
  let arr = search.split("?");
  let params = new URLSearchParams(arr[1]);
  let platform = params.get("platform");
  return platform;
}

function _formatDayNoHour(str) {
  if (str) {
    return moment(str).format("DD/MM/YYYY");
  }
  return "";
}

function _formatDay(str) {
  if (str) {
    return moment.utc(str).format("DD/MM/YYYY HH:mm:ss");
  }
  return "";
}

function _formatH(str) {
  if (str) {
    return moment(str).format("h:mm a");
  }
  return "";
}

function _renderData(value) {
  var data = value;
  var newdata = [];
  for (var i = 0; i < parseInt(data.length); i++) {
    var item = {
      insuredName: data[i]?.fullname,
      insuredPhone: data[i]?.phoneNumber,
      insuredDob: _formatDayNoHour(data[i]?.birthday),
      insuredEmail: data[i]?.email,
      insuredPrivateId: data[i]?.privateId,
    };
    newdata.push(item);
  }
  return newdata;
}

function _checkEndate(value) {
  var toDay = _formatDay(new Date());
  var endDate = _formatDay(value);
  // var data = moment(new Date(), 'DD/MM/YYYY').isAfter(moment(value, 'DD/MM/YYYY'));
  var data = moment(toDay, "DD/MM/YYYY").isAfter(moment(endDate, "DD/MM/YYYY"));
  return data;
}

function capitalize(str) {
  if (!str) {
    return "";
  }
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
}
function _calculateAge(dob) {
  if (dob) {
    let age = moment()
      .month(0)
      .diff(moment(dob, "DD/MM/YYYY").month(0), "years");
    return age;
  }
}

function tinhTuoiVaNgayDuRa(ngaySinh) {
  // Chuyển đổi chuỗi ngày sinh thành đối tượng Moment
  // Kiểm tra xem ngày sinh có hợp lệ không

  // Lấy ngày hiện tại
  const ngayHienTaiMoment = moment();

  // Tính toán tuổi
  const tuoi = ngayHienTaiMoment.diff(ngaySinh, "years");

  // Tính toán số ngày dư ra
  const soNgayDuRa = ngayHienTaiMoment.diff(ngaySinh, "days") % 365;
  return { tuoi, soNgayDuRa };
}

const Benefits = [
  // đồng
  {
    ql1: "50.000.000",
    ql2: "25.000.000",
    ql3: "5.000.000",
    ql4: "12.500.000",
    ql41: "625.000",
    qlbaohiem: "Chi phí thực tế, tối đa 625.000đ/ngày",
    ql42: "12.500.000",
    qlbaohiem42: "Theo thực tế, tối đa không quá hạn mức tại mục 4",
    qlkhac1: "625.000",
    qlkhac2: "625.000",
    qlkhac3: "625.000",
    qlkhac4: "25.000",
    qlkhac5: "Theo thực tế, tối đa không quá số tiền BH",
    qlkhac6: "625.000",
    qlbs1: "Không hỗ trợ",
    qlbs11: "Không hỗ trợ",
    qlbs12: "Không hỗ trợ",
    qlbs13: "Không hỗ trợ",
    qlbs14: "Không hỗ trợ",
    qlbs15: "Không hỗ trợ",
    qlbs16: "Không hỗ trợ",
    qlbs17: "Không hỗ trợ",
    qlbs2: "Không hỗ trợ",
    qlbs2ngoaitru: "Không hỗ trợ",
    qlbs2khambenh: "Không hỗ trợ",
    qlbs3: "Không hỗ trợ",
    qlbs3ngoaitru: "Không hỗ trợ",
    qlbs3khambenh: "Không hỗ trợ",
    qlbs4: "1.500.000",
    namvientainan: "25.000",
    qlbs5: "Không bảo lãnh",
  },
  // Bạc
  {
    ql1: "100.000.000",
    ql2: "50.000.000",
    ql3: "10.000.000",
    ql4: "25.000.000",
    ql41: "1.250.000",
    qlbaohiem: "Chi phí thực tế, tối đa 1.250.000đ/ngày",
    ql42: "25.000.000",
    qlbaohiem42: "Theo thực tế, tối đa không quá hạn mức tại mục 4",
    qlkhac1: "1.250.000",
    qlkhac2: "1.250.000",
    qlkhac3: "1.250.000",
    qlkhac4: "50.000",
    qlkhac5: "Theo thực tế, tối đa không quá số tiền BH",
    qlkhac6: "1.250.000",
    qlbs1: "5.000.000",
    qlbs11: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs12: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs13: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs14: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs15: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs16: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs17: "50.000",
    qlbs2: "2.500.000",
    qlbs2ngoaitru: "2.500.000",
    qlbs2khambenh:
      "Chi phí thực tế, không quá 500,000đ /1 lần khám, tối đa 5 lần/năm",
    qlbs3: "500.000",
    qlbs3ngoaitru: "500.000",
    qlbs3khambenh: "Chi phí thực tế, tối đa 5 lần/năm",
    qlbs4: "3.000.000",
    namvientainan: "50.000",
    qlbs5: "Nội trú",
  },
  // Titan
  {
    ql1: "200.000.000",
    ql2: "100.000.000",
    ql3: "20.000.000",
    ql4: "50.000.000",
    ql41: "2.500.000",
    qlbaohiem: "Chi phí thực tế, tối đa 2.500.000đ/ngày",
    ql42: "50.000.000",
    qlbaohiem42: "Theo thực tế, tối đa không quá hạn mức tại mục 4",
    qlkhac1: "2.500.000",
    qlkhac2: "2.500.000",
    qlkhac3: "2.500.000",
    qlkhac4: "100.000",
    qlkhac5: "Theo thực tế, tối đa không quá số tiền BH",
    qlkhac6: "2.000.000",
    qlbs1: "10.000.000",
    qlbs11: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs12: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs13: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs14: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs15: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs16: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs17: "100.000",
    qlbs2: "5.000.000",
    qlbs2ngoaitru: "5.000.000",
    qlbs2khambenh:
      "Chi phí thực tế, không quá 1.000,000đ /1 lần khám, tối đa 10 lần/năm",
    qlbs3: "1.000.000",
    qlbs3ngoaitru: "1.000.000",
    qlbs3khambenh:
      "Chi phí thực tế, không quá 500,000đ /1 lần khám, tối đa 5 lần/năm",
    qlbs4: "6.000.000",
    namvientainan: "100.000",
    qlbs5: "Nội trú",
  },
  // Vàng
  {
    ql1: "500.000.000",
    ql2: "250.000.000",
    ql3: "50.000.000",
    ql4: "125.000.000",
    ql41: "6.250.000",
    qlbaohiem: "Chi phí thực tế, tối đa 6.250.000đ/ngày",
    ql42: "125.000.000",
    qlbaohiem42: "Theo thực tế, tối đa không quá hạn mức tại mục 4",
    qlkhac1: "6.250.000",
    qlkhac2: "6.250.000",
    qlkhac3: "6.250.000",
    qlkhac4: "150.000",
    qlkhac5: "Theo thực tế, tối đa không quá số tiền BH",
    qlkhac6: "2.000.000",
    qlbs1: "20.000.000",
    qlbs11: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs12: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs13: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs14: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs15: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs16: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs17: "200.000",
    qlbs2: "10.000.000",
    qlbs2ngoaitru: "10.000.000",
    qlbs2khambenh:
      "Chi phí thực tế, không quá 1.200.000đ /1 lần khám, tối đa 10 lần/năm",
    qlbs3: "2.000.000",
    qlbs3ngoaitru: "2.000.000",
    qlbs3khambenh:
      "Chi phí thực tế, không quá 1.000,000đ /1 lần khám, tối đa 5 lần/năm",
    qlbs4: "12.000.000",
    namvientainan: "200.000",
    qlbs5: "Nội trú",
  },
  // Bach kim
  {
    ql1: "1.000.000.000",
    ql2: "500.000.000",
    ql3: "100.000.000",
    ql4: "250.000.000",
    ql41: "12.500.000",
    qlbaohiem: "Chi phí thực tế, tối đa 12.500.000đ/ngày",
    ql42: "250.000.000",
    qlbaohiem42: "Theo thực tế, tối đa không quá hạn mức tại mục 4",
    qlkhac1: "12.500.000",
    qlkhac2: "12.500.000",
    qlkhac3: "12.500.000",
    qlkhac4: "300.000",
    qlkhac5: "Theo thực tế, tối đa không quá số tiền BH",
    qlkhac6: "2.000.000",
    qlbs1: "40.000.000",
    qlbs11: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs12: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs13: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs14: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs15: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs16: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs17: "400.000",
    qlbs2: "20.000.000",
    qlbs2ngoaitru: "20.000.000",
    qlbs2khambenh:
      "Chi phí thực tế, không quá 2.000.000đ /1 lần khám, tối đa 10 lần/năm",
    qlbs3: "4.000.000",
    qlbs3ngoaitru: "4.000.000",
    qlbs3khambenh:
      "Chi phí thực tế, không quá 2.000,000đ /1 lần khám, tối đa 5 lần/năm",
    qlbs4: "18.000.000",
    namvientainan: "300.000",
    qlbs5: "Nội trú,ngoại trú và nha khoa",
  },
  // kim cương
  {
    ql1: "2.000.000.000",
    ql2: "1.000.000.000",
    ql3: "200.000.000",
    ql4: "400.000.000",
    ql41: "20.000.000",
    qlbaohiem: "Chi phí thực tế, tối đa 20.000.000đ/ngày",
    ql42: "400.000.000",
    qlbaohiem42: "Theo thực tế, tối đa không quá hạn mức tại mục 4",
    qlkhac1: "20.000.000",
    qlkhac2: "20.000.000",
    qlkhac3: "20.000.000",
    qlkhac4: "400.000",
    qlkhac5: "Theo thực tế, tối đa không quá số tiền BH",
    qlkhac6: "2.000.000",
    qlbs1: "64.000.000",
    qlbs11: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs12: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs13: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs14: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs15: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs16: "Theo thực tế, không quá số tiền quyền lợi thai sản",
    qlbs17: "640.000",
    qlbs2: "32.000.000",
    qlbs2ngoaitru: "32.000.000",
    qlbs2khambenh:
      "Chi phí thực tế, không quá 6.400,000đ /1 lần khám, tối đa 10 lần/năm",
    qlbs3: "10.000.000",
    qlbs3ngoaitru: "10.000.000",
    qlbs3khambenh:
      "Chi phí thực tế, không quá 4.000,000đ /1 lần khám, tối đa 5 lần/năm",
    qlbs4: "60.000.000",
    namvientainan: "1.000.000",
    qlbs5: "Nội trú,ngoại trú và nha khoa",
  },
];
const variable = {
  _params,
  getParamUrl,
  getParamUrlByKey,
  _formatMoney,
  _addEffectiveDate,
  _getTPlatformParamUrl,
  _renderData,
  _formatDayNoHour,
  _formatH,
  _validPhone,
  _formatDay,
  _checkEndate,
  capitalize,
  _calculateAge,
  Benefits,
  tinhTuoiVaNgayDuRa,
};
export default variable;
